import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import logo from '/imageAssets/pfizer-logo-color.png';

const HomePlaceholder = ({ isVisible, onAnimationStart, onAnimationComplete }) => {
  const placeholderRef = useRef(null);
  const logoRef = useRef(null);

  useEffect(() => {
    if (isVisible) {
      const timeline = gsap.timeline({
        onComplete: onAnimationComplete
      });

      timeline.fromTo(placeholderRef.current,
        { y: '100%' },
        { y: '0%', duration: 0.5, ease: 'power2.out', onComplete: onAnimationStart }
      );

      timeline.fromTo(logoRef.current,
        { opacity: 0, scale: 0.5 },
        { opacity: 1, scale: 1, duration: 0.5, ease: 'back.out(1.7)' },
        '-=0.3'
      );

      timeline.to({}, { duration: 3 }); // Reduced to 3 seconds to account for initial animation

      timeline.to(placeholderRef.current,
        { y: '-100%', duration: 0.5, ease: 'power2.in' }
      );
    }
  }, [isVisible, onAnimationStart, onAnimationComplete]);

  return (
    <div ref={placeholderRef} className="home-placeholder" style={{ display: isVisible ? 'flex' : 'none' }}>
      <img ref={logoRef} src={logo} alt="Pfizer Logo" className="home-logo" />
    </div>
  );
};

export default HomePlaceholder;